import React from 'react';
import { Box, Grid, Card, CardContent, Typography, Divider, Stack } from '@mui/material';

import CheckIcon from '@mui/icons-material/Check';

const plans = [
  {
    title: 'Essential Care',
    subtitle: 'You care for your inside, we care for your outside!',
    features: [
      { text: (<><b>Ixoria Anti Acne Face Mask</b> (100g)</>), bold: true },
      { text: (<><b>21 Day Progress Track Book</b> (Track mask use, food, water, sleep, mood & more)</>), bold: false },
      { text: (<><b>Free Delivery</b> – All Over India</>), bold: false },
    ],
    oldPrice: '₹1100',
    price: '₹999',
    highlight: false,
    pillExtra: '',
    subtitleColor: '#0a716e',
    subtitleWeight: 500,
  },
  {
    title: 'Balanced Care',
    subtitle: 'Personalized care with expert support!',
    features: [
      { text: (<><b>Everything in Essential Care</b></>), bold: true },
      { text: (<>1-on-1 Ayurvedic <b>Doctor Consultation</b></>), bold: false },
      { text: (<>Personalized prescription based on your acne cause & body type</>), bold: false },
      { text: (<>Custom <b>diet & lifestyle guidance</b></>), bold: false },
      { text: (<>1 <b>Free Follow-Up</b> after 10 days</>), bold: false },
    ],
    oldPrice: '₹1500',
    price: '₹1299',
    highlight: true,
    pillExtra: '',
    subtitleColor: '#0a716e',
    subtitleWeight: 500,
  },
  {
    title: 'Advanced Care',
    subtitle: 'We take care of everything. You just focus on healing',
    features: [
      { text: (<><b>Everything in Essential Care</b></>), bold: true },
      { text: (<>1-on-1 Ayurvedic <b>Doctor Consultation</b></>), bold: false },
      { text: (<>Custom <b>diet & lifestyle guidance</b></>), bold: false },
      { text: (<>Doctor-prescribed <b>oral medicines shipped to your address</b></>), bold: false },
      { text: (<>3 <b>Free Follow-Ups</b> over 40 days</>), bold: false },
    ],
    oldPrice: '',
    price: '₹1399',
    highlight: false,
    pillExtra: '+ Medicine Cost',
    subtitleColor: '#0a716e',
    subtitleWeight: 500,
  },
];

export default function PlansSection() {
  return (
    <Box sx={{ width: '100%', bgcolor: '#fff', py: { xs: 4, md: 8 }, display: 'flex', justifyContent: 'center', alignItems: 'center', mx: 'auto', maxWidth: 1400 }}>
      <Grid container spacing={{ xs: 2, md: 4 }} justifyContent="center" alignItems="center" sx={{ width: '100%' }} >
        {plans.map((plan, idx) => (
          <Grid item xs={12} sm={4} key={plan.title} sx={{ display: 'flex', justifyContent: 'center', px: { xs: 0, sm: 2, md: 3 }, py: { xs: 1.5, sm: 2 } }}>
            <Card
              sx={{
                border: 0,
                borderRadius: 2,
                boxShadow: plan.highlight ? 16 : 2,
                overflow: 'hidden',
                minHeight: idx === 1 ? { xs: 420, sm: 650 } : { xs: 320, sm: 580 },
                width: { xs: 350, sm: 320, md: 1 },
                maxWidth: { xs: 350, sm: 370, md: 420 },
                display: 'flex',
                flexDirection: 'column',
                pb: 2,
                transition: 'box-shadow 0.3s cubic-bezier(.4,2,.6,1), transform 0.8s cubic-bezier(.4,2,.6,1)',
                borderColor: 'transparent',
                '&:hover': {
                  boxShadow: 16,
                  transform: 'translateY(-10px) scale(1.02)',
                  borderColor: plan.highlight ? '#0a716e' : '#b2dfdb',
                  borderWidth: 0.5,
                  borderStyle: 'solid',
                },
              }}
            >
              {/* Top Bar */}
              <Box sx={{
                bgcolor: '#0a716e',
                py: 2.5,
                px: 3,
                borderTopLeftRadius: 2,
                borderTopRightRadius: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <Typography sx={{ color: '#fff', fontWeight: 500, fontSize: { xs: 26, md: 32, lg: 40 }, letterSpacing: 0.2, mr: 1 }}>
                  {plan.title.split(' ')[0]}
                </Typography>
                <Typography sx={{ color: '#fff', fontWeight: 300, fontSize: { xs: 26, md: 32, lg: 40 } }}>
                  {plan.title.replace(plan.title.split(' ')[0], '')}
                </Typography>
              </Box>

              {/* Subtitle/Description */}
              <Box sx={{ px: { xs: 2, md: 4 }, pt: 3, pb: 1 }}>
                <Typography sx={{ color: plan.subtitleColor, fontWeight: plan.subtitleWeight, fontSize: { xs: 16, md: 18, lg: 22 }, textAlign: 'left', mb: 2 }}>
                  {plan.subtitle}
                </Typography>
              </Box>

              {/* Features List */}
              <Box sx={{ px: { xs: 2, md: 4 }, pb: 2 }}>
                <Stack spacing={1.2}>
                  {plan.features.map((f, i) => (
  <Box key={typeof f.text === 'string' ? f.text : `feature-${i}`} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
    <CheckIcon sx={{ color: '#0a716e', mt: '2px', mr: 1, fontSize: 22 }} />
    <Typography sx={{ color: '#222', fontSize: { xs: 16, md: 18 }, fontWeight: f.bold ? 600 : 400, textAlign: 'left', lineHeight: 1.35 }}>
      {f.text}
    </Typography>
  </Box>
))}
                </Stack>
              </Box>

              {/* Price Display */}
              <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 'auto', pt: 2, gap: 0.5 }}>
                {plan.oldPrice && (
                  <Typography sx={{ 
                    color: '#888', 
                    textDecoration: 'line-through', 
                    fontWeight: 400, 
                    fontSize: { xs: 18, md: 22 },
                    lineHeight: 1.2
                  }}>
                    {plan.oldPrice}
                  </Typography>
                )}
                <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 1 }}>
                  <Typography sx={{ 
                    color: '#222', 
                    fontWeight: 700, 
                    fontSize: { xs: 28, md: 36 },
                    lineHeight: 1
                  }}>
                    {plan.price}
                  </Typography>
                  {plan.pillExtra && (
                    <Typography sx={{ 
                      color: '#0a716e', 
                      fontWeight: 500, 
                      fontSize: { xs: 16, md: 20 },
                      mb: 0.5
                    }}>
                      {plan.pillExtra}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

